import { faInbox } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";

const EmptyState = ({
  title = "No Data Found",
  description = "There is nothing to display here yet.",
  buttonText,
  onButtonClick,
  icon,
}) => {
  const iconToUse = icon || faInbox;

  return (
    <div
      style={{
        padding: "60px 20px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#6c757d",
      }}
    >
      <FontAwesomeIcon
        icon={iconToUse}
        style={{
          fontSize: "50px",
          marginBottom: "20px",
          opacity: 0.6,
        }}
      />

      <h5
        style={{
          fontWeight: 600,
          marginBottom: "8px",
        }}
      >
        {title}
      </h5>

      <p
        style={{
          maxWidth: "420px",
          fontSize: "14px",
          marginBottom: buttonText ? "20px" : "0",
        }}
      >
        {description}
      </p>

      {buttonText && (
        <Button variant="primary" onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
